// React import
import { useCallback, useEffect, useRef } from "react";

// Context and hooks imports
import usePages from "../../../Hooks/Display/usePages";

// Component imports
import { Popup } from "@progress/kendo-react-popup";
import { Menu, MenuItem } from "@progress/kendo-react-layout";

// Events import
import { TOGGLE_CONTEXT_MENU, TOGGLE_DELETE_PAGE_DIALOG, TOGGLE_EDIT_PAGE_DIALOG } from "../../../Context/Display/Pages/PagesContextEvents";

function ContextMenu() {

    const [{ showContextMenu, contextMenuOffset, contextMenuItemIndex }, dispatchPageEvent] = usePages();

    const popup = useRef(null);
    useEffect(() => {
        function checkOutsideClick(e) {
            if (popup.current !== null && !popup.current.contains(e.target)) {
                if (showContextMenu) {
                    toggleContextMenu()
                }
            }
        }

        document.addEventListener("click", checkOutsideClick);

        return () => {
            document.removeEventListener("click", checkOutsideClick);
        }
    }, [showContextMenu])

    function showDeleteOption() {
        return true
    }

    function showCopyOption() {
        return true;
    }

    function handleEdit() {
        dispatchPageEvent({
            type: TOGGLE_EDIT_PAGE_DIALOG,
            payload: contextMenuItemIndex
        })
    }

    function handleDelete() {
        dispatchPageEvent({
            type: TOGGLE_DELETE_PAGE_DIALOG,
            payload: contextMenuItemIndex
        })
    }

    function handleCopy() {
        console.log("Copy");
    }

    function handlePaste() {
        console.log("Paste");
    }

    function handleMenuItemSelect(event) {
        switch(event.itemId) {
            case '0':
                handleEdit();
                break;
            case '1':
                handleDelete();
                break;
            case '2':
                handleCopy();
                break;
            case '3':
                handlePaste();
                break;
            default:
                break;
        }
        toggleContextMenu();
    }

    function toggleContextMenu() {
        dispatchPageEvent({
            type: TOGGLE_CONTEXT_MENU,
            payload: {}
        })
    }

    return (
        <Popup
            animate={false}
            style={{ width: "150px" }}
            show={showContextMenu}
            offset={contextMenuOffset}
        >
            <div className="w-100" ref={menu => popup.current = menu}>
                <Menu
                    vertical
                    style={{ display: "inline-block", width: "100%" }}
                    onSelect={handleMenuItemSelect}
                >
                    <MenuItem text="Edit" />
                    {
                        showDeleteOption() &&
                        <MenuItem text="Delete" />
                    }
                    {
                        showCopyOption() ?
                        <MenuItem text="Copy" /> : null
                    }
                    {
                        showCopyOption() &&
                        localStorage.getItem("copiedPageInformation") !== null &&
                        localStorage.getItem("copiedPageInformation") !== "" ?
                        <MenuItem text="Paste" /> : null
                    }
                </Menu>
            </div>
        </Popup>
    )
}

export default ContextMenu;